/* eslint-disable @typescript-eslint/no-explicit-any */
import { KeplerGlLayers } from '@carto/kepler.gl/layers'

export default class GeojsonLayer extends KeplerGlLayers.GeojsonLayer {
  [x: string]: any

  constructor(props: any) {
    super(props)
    this.config.visConfig.filled = true
  }

  get name() {
    return 'Polygon'
  }
}
